import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function useBisWaitlistSmsWebMwebExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.BIS_WAITLIST_SMS_WEB_MWEB)
  return experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
}
